import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { rocketGameLiveService } from '../../../services/rockets-games-lives'
import type { GetFirst } from '../../../services/rockets-games-lives/types'

export const ROCKET_GAME_LIVE_FIRST_QUERY_KEY = 'getRocketGameLiveFirst'

export const useGetRocketGameLiveFirst = (params: GetFirst.Input) => {
  const queryClient = useQueryClient()

  const { data, isLoading, refetch } = useQuery({
    queryKey: [ROCKET_GAME_LIVE_FIRST_QUERY_KEY, params],
    queryFn: () => {
      return rocketGameLiveService.getFirst(params)
    },
  })

  const get = useCallback(
    async (getParams: GetFirst.Input) => {
      const response = await queryClient.fetchQuery({
        queryKey: [ROCKET_GAME_LIVE_FIRST_QUERY_KEY, getParams],
        queryFn: () => {
          return rocketGameLiveService.getFirst(getParams)
        },
      })

      return response?.data
    },
    [queryClient],
  )

  return {
    rocketGameLive: data?.data,
    isLoading: isLoading,
    get,
    refetch,
  }
}
